import React from 'react'
import { Grid, GridCell, Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { useOrganization } from 'src/core/graphql/hooks'
import ContentView from 'src/sites/kits/UI/Content/View'
import { useGlobalState } from 'src/sites/state'
import SocialMedia from '../SocialMedia'

// =======================================================
// Component
// =======================================================

const Footer = ({
   backgroundColor,
   paddingLeft,
   paddingRight,
   textColor
}) => {
   const { theme } = useGlobalState()
   const { organization } = useOrganization()
   const currentYear = new Date().getFullYear()

   if (organization.customFooter) {
      return <ContentView elements={organization.customFooter.elements} />
   }

   return (
      <View
         display="flex"
         justifyContent="center"
         float="left"
         width="100%"
         height="180px"
         paddingVertical="30px"
         backgroundColor={backgroundColor || '#eee'}>
         <View
            width="100%"
            paddingLeft={paddingLeft || theme.tmpViewportPadding}
            paddingRight={paddingRight || theme.tmpViewportPadding}>
            <Grid columns="12">
               <GridCell colspan="12[a-c] 6[d-f]">
                  <Text size="1.5" color={textColor}>
                     &copy;
                     {` ${currentYear} ${organization.name}`}
                     {!organization.name.endsWith('.') && '.'}
                     {' All Rights reserved.'}
                  </Text>
               </GridCell>
               <GridCell colspan="12[a-c] 6[d-f]">
                  <View
                     float="left"
                     width="100%"
                     display="flex"
                     justifyContent="flex-start[a-c] flex-end[d-f]">
                     <SocialMedia
                        color={textColor}
                        format="icon-only"
                     />
                  </View>
               </GridCell>
            </Grid>
         </View>
      </View>
   )
}

// =======================================================
// Props, Decorators & Export
// =======================================================

Footer.propTypes = {
   backgroundColor: PropTypes.string,
   paddingLeft: PropTypes.string,
   paddingRight: PropTypes.string,
   textColor: PropTypes.string
}

Footer.defaultProps = {
   backgroundColor: undefined,
   paddingLeft: undefined,
   paddingRight: undefined,
   textColor: '#666'
}

export default Footer
